import React from 'react';
import Tooltip from './Tooltip';

export default props => <Tooltip hidePrimary {...props} />;
